define('home/views/ChannelLeadersCollectionView',[
    'underscore',
    'backbone-marionette',

    'home/views/ChannelLeadingUserView',
    'home/views/ChannelLeadersEmptyView',
], function (
    _,
    Marionette,

    ChannelLeadingUserView,
    ChannelLeadersEmptyView
) {
    'use strict';

    /**
     * A view of a collection of users who are leaders (either top contributors or mods) for
     * a channel.
     *
     * Expects to be given a collection of users, a model that contains the channel for which
     * the users are leaders, the index after which items in the collection are collapsed,
     * and the type of leaders list represented (leaders or mods).
     */
    var ChannelLeadersCollectionView = Marionette.CollectionView.extend({
        itemView: ChannelLeadingUserView,
        emptyView: ChannelLeadersEmptyView,
        tagName: 'ul',
        className: 'leader-list',

        initialize: function (options) {
            this.collapsedSize = options.collapsedSize;
            this.type = options.type;
        },

        itemViewOptions: function (_item, index) {
            // emptyView expects to be passed the type
            if (this._showingEmptyView) {
                return {
                    type: this.type,
                };
            }

            // Used in className which is called without this as the context
            var collapsedSize = this.collapsedSize;

            return {
                channel: this.model.channel,
                index: index,
                showIndex: this.type === 'leaders',
                hideModBadge: this.type === 'mods',
                className: function () {
                    var existing = ChannelLeadingUserView.prototype.className;
                    if (_.isFunction(existing))
                        existing = existing.call(this);

                    var className = existing || '';

                    // Mark items beyond some threshold to be collapsible. These
                    // won't be shown when the module is collapsed and will be
                    // shown when the module is expanded.
                    if (index >= collapsedSize)
                        className += ' collapsible';

                    return className;
                },
            };
        },
    });

    return ChannelLeadersCollectionView;
});

